module.exports = __webpack_public_path__ + "static/kovka5-eb581ad8997b26a442fe34d5554462ee.png";